var easyAppointmentItems = null;

async function checkCartItemsDuration() {
    if(!easyAppointmentItems) {
        const cartData = await fetch("/cart.js");
        const cartDataJson = await cartData.json();
    
        easyAppointmentItems = cartDataJson.items.filter(cartItem => cartItem.properties["Start Date"]);
    }
    
    
    if(!easyAppointmentItems || easyAppointmentItems.length == 0) {
        return false;
    }

    let lastDuration = localStorage.getItem("easyAppointmentFixTimeAdded");

    if(!lastDuration) {
        return false;
    }

    lastDuration = parseInt(lastDuration);
    const pastTime = Date.now() - lastDuration;

    // check if time > 10 minutes and then remove cart items
    if(pastTime > 600000) {
        updates = {}

        easyAppointmentItems.forEach(item => updates[item.variant_id] = 0)

        console.log("Removing EasyAppointmentItems where the event time is > 10 minutes")

        // Remove Items via API
        await fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates
            })
        });

        localStorage.removeItem("easyAppointmentFixTimeAdded");

        return true;
    }
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// settings time where item was added on button click for easy appointment 
waitForElm("[data-servicify='servicify-add-to-cart-button']").then(button => {
    button.addEventListener("click", () => {
        localStorage.setItem("easyAppointmentFixTimeAdded", Date.now());
        console.log("Setting easyAppointmentFixTimeAdded");
    })
});


// cart drawer listener
document.querySelector("a[aria-controls='CartDrawer'").addEventListener("click", () => {
    checkCartItemsDuration().then((res) => {
        if(res) {
            console.log("ajaxproduct added evt")
            document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
        }
    })
});


checkCartItemsDuration().then((res) => {
    // listener for traditional cart page
    if(res) {
        window.location.reload();
    }

    // add interval, e.g. when user stays in the cart so that the products get removed
    if(easyAppointmentItems && easyAppointmentItems.length != 0) {
        setInterval(async () => {
            console.log("Running Check Interval");
            const resultCheck = await checkCartItemsDuration();
            if(resultCheck) {
                window.location.reload();
            }
        }, 1000);
    }
    
});

